import { Overrides } from '@material-ui/core/styles/overrides';

export const initializeAccordionSummaryOverrides = (
  config?: Overrides['MuiAccordionSummary']
): Overrides['MuiAccordionSummary'] => {
  return {
    root: {},
    ...config,
  };
};
